import { Wrench } from "lucide-react";
import { useQrMaintenance } from "@/lib/qrMaintenance";

/**
 * Notice shown while QR payments are switched off for maintenance.
 * Renders nothing when the backend says payments are running normally.
 */
export const QrMaintenanceBanner = ({ className = "" }) => {
  const { active, title, text } = useQrMaintenance();

  if (!active) return null;

  return (
    <div
      role="status"
      className={`mx-4 mb-3 flex items-start gap-3 rounded-2xl border border-amber-200 bg-amber-50 p-4 dark:border-amber-500/30 dark:bg-amber-900/25 ${className}`}
      data-testid="qr-maintenance-banner"
    >
      <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-500/20">
        <Wrench className="h-4 w-4 text-amber-700 dark:text-amber-300" />
      </div>
      <div className="min-w-0">
        <h3 className="text-sm font-semibold text-amber-900 dark:text-amber-100">{title}</h3>
        <p className="mt-1 text-xs leading-relaxed text-amber-800/90 dark:text-amber-200/90">{text}</p>
      </div>
    </div>
  );
};

export default QrMaintenanceBanner;
